import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_BUTTON_BORDER, PRIMARY_BUTTON_BACKGROUND, LIGHT_TEXT } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    mainCont: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },

    buttonCls: {
      height: '60px !important',
      borderColor: PRIMARY_BUTTON_BORDER,
      borderRadius: '8px !important',
      padding: 1,
      fontSize: 16,
      maxWidth: 390,
      minWidth: 390,
      marginTop: 50,
      [theme.breakpoints.down(960)]: {
        maxWidth: '100%',
        minWidth: '100%',
      },
    },
    registerBtn: {
      backgroundColor: PRIMARY_BUTTON_BACKGROUND,
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      padding: 1,
      fontSize: 16,
    },
    agencyLogo: {
      objectFit: 'contain',
      maxWidth: 500,
      [theme.breakpoints.down(960)]: {
        maxWidth: '100%',
        minWidth: '100%',
        maxHeight: 300,
      },
    },

    welcomeMessage: {
      fontSize: 18,
      textAlign: 'justify',
      whiteSpace: 'break-spaces',
    },
    logoPlaceholder: {
      border: '3px dashed lightgray',
      padding: 20,
      fontSize: 28,
      borderRadius: 8,
    },
    input: {
      maxWidth: 390,
      background: 'none',
      borderRadius: 8,
      fontWeight: 400,
      '& input': {
        fontSize: 14,
      },
      '& .MuiInputBase-root': {
        paddingLeft: 20,
        borderRadius: 8,
      },
    },

    startIcon: {
      fontSize: 20,
      marginRight: 5,
    },
    helpText: {
      color: LIGHT_TEXT,
      textAlign: 'left',
      maxWidth: 390,
      lineHeight: 1.2,
    },

    formContainer: {
      margin: '50px auto 0',
      maxWidth: 390,
    },
  }),
);
